// import React from "react";
// import { TrendingUp, TrendingDown } from "lucide-react";

// export default function VarianceCard({
//   title = "Variance",

//   amount = "₹0.00L",

//   subtitle = "",

//   bgColor = "#ecfdf5",

//   textColor = "#15803d",

//   icon = "up",
// }) {
//   return (
//     <div
//       style={{
//         background: bgColor,
//         borderRadius: "12px",
//         padding: "18px 20px",
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "flex-start",
//         width: "100%",
//       }}
//     >
//       <div>
//         <p
//           style={{
//             fontSize: "14px",
//             color: textColor,
//             marginBottom: "0px",
//             fontWeight: "400",
//           }}
//         >
//           {title}
//         </p>

//         <h3
//           style={{
//             fontSize: "30px",
//             fontWeight: "700",
//             color: textColor,
//             marginTop: "10px",
//           }}
//         >
//           {amount}
//         </h3>

//         <p
//           style={{
//             fontSize: "14px",
//             color: textColor,

//             // marginTop: "4px",
//             marginBottom: "0px",
//             fontWeight: "400",
//           }}
//         >
//           {subtitle}
//         </p>
//       </div>

//       <div>
//         {icon === "up" ? (
//           <TrendingUp size={20} color={textColor} />
//         ) : (
//           <TrendingDown size={20} color={textColor} />
//         )}
//       </div>
//     </div>
//   );
// }

import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import StyledTooltip from "./StyledTooltip";
// import "./VarianceCard.scss";

export default function VarianceCard({
  title = "Variance",

  amount = "₹0.00L",

  originalValue = 0,

  subtitle = "",

  bgColor = "#ecfdf5",

  textColor = "#15803d",

  icon = "up",
}) {
  return (
    <div
      className="variance-card"
      style={{
        background: bgColor,
        color: textColor,
      }}
    >
      <div>
        <p className="variance-card__title">{title}</p>

        <StyledTooltip value={originalValue}>
          <h3 className="variance-card__amount" style={{ color: textColor }}>
            {amount}
          </h3>
        </StyledTooltip>

        <p className="variance-card__subtitle">{subtitle}</p>
      </div>

      <div className="variance-card__icon">
        {icon === "up" ? (
          <TrendingUp size={20} color={textColor} />
        ) : (
          <TrendingDown size={20} color={textColor} />
        )}
      </div>
    </div>
  );
}
